// Data for PayMap landing page
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const heroData = {
  headline: "Finally see which paycheck covers which bills.",
  subheadline: "PayMap helps bi-weekly workers map paydays to bills so you always know where you stand — week by week.",
  primaryCTA: "Get Early Access",
  secondaryCTA: "See How It Works"
};

export const problemData = {
  headline: "Getting paid every two weeks makes budgeting messy.",
  problems: [
    "Bills don't align with paydays.",
    "Monthly budgets hide weekly shortfalls.",
    "It's hard to know if you're safe this week."
  ],
  closing: "Most budgeting apps assume monthly salary. Real life doesn't."
};

export const solutionData = {
  headline: "With PayMap, you can:",
  benefits: [
    "Map bills directly to pay cycles",
    "See weekly net totals instantly",
    "Know which week runs negative",
    "Plan ahead before it becomes stressful"
  ],
  features: [
    "No bank sync.",
    "No complicated setup.",
    "Just clarity."
  ]
};

export const featuresData = [
  {
    id: 1,
    title: "Paycheck-Aligned Calendar",
    description: "Visualize your income and bills across real pay cycles.",
    icon: "Calendar"
  },
  {
    id: 2,
    title: "Weekly Net Tracking",
    description: "See red or green each week so you know where you stand.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Multiple Calendars",
    description: "Perfect for couples or separate accounts.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Customizable Themes",
    description: "Make it yours — without sacrificing clarity.",
    icon: "Palette"
  }
];

export const pricingData = {
  title: "Early Access Lifetime",
  price: "$29",
  priceNote: "one-time",
  features: [
    "Unlimited calendars",
    "All features",
    "Future updates",
    "Priority feature consideration"
  ],
  notice: "Price increases after early launch."
};

export const footerData = {
  tagline: "Clarity between paydays.",
  links: [
    { label: "Privacy Policy", href: "/paymap/privacy" },
    { label: "Contact", href: "mailto:support@paymaplabs.com" }
  ],
  copyright: "© 2026 PayMap. All rights reserved."
};

// API function to handle signup
export const signupForEarlyAccess = async (email) => {
  try {
    const response = await fetch(`${API}/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Signup error:", error);
    throw error;
  }
};

// API function to get signup count
export const getSignupCount = async () => {
  // Hardcoded for testing
  return 4;
};
